const CartAPI = {
  timeoutMs: 10000,

  routes: {
    add: 'cart/add.js',
    change: 'cart/change.js',
    update: 'cart/update.js',
    get: 'cart.js',
    clear: 'cart/clear.js',
  },

  getRoot() {
    return window.Shopify?.routes?.root || '/';
  },

  // Errors carry a `code`, never a user-facing string: `description` is reserved for
  // Shopify's own localised error bodies, and CartMutations falls back to the error
  // slot's Liquid-sourced message whenever it is absent.
  async _fetch(url, options = {}) {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), this.timeoutMs);
    try {
      const response = await fetch(url, { ...options, signal: controller.signal });
      let data;
      try {
        data = await response.json();
      } catch {
        throw { code: 'invalid_response' };
      }
      if (!response.ok) throw data;
      return data;
    } catch (error) {
      if (error.name === 'AbortError') throw { code: 'timeout' };
      if (error.description) throw error;
      throw error.code ? error : { code: 'network', cause: error };
    } finally {
      clearTimeout(timer);
    }
  },

  async add(formData, sections = []) {
    if (sections.length) {
      formData.append('sections', sections.join(','));
      formData.append('sections_url', window.location.pathname);
    }
    return this._fetch(`${this.getRoot()}${this.routes.add}`, {
      method: 'POST',
      body: formData,
    });
  },

  async addMultiple(items, sections = []) {
    const body = { items };
    if (sections.length) {
      body.sections = sections.join(',');
      body.sections_url = window.location.pathname;
    }
    return this._fetch(`${this.getRoot()}${this.routes.add}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    });
  },

  async change(id, quantity, sections = []) {
    const body = { id, quantity };
    if (sections.length) {
      body.sections = sections.join(',');
      body.sections_url = window.location.pathname;
    }
    return this._fetch(`${this.getRoot()}${this.routes.change}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    });
  },

  async update(body, sections = []) {
    if (sections.length) {
      body.sections = sections.join(',');
      body.sections_url = window.location.pathname;
    }
    return this._fetch(`${this.getRoot()}${this.routes.update}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    });
  },

  async get() {
    return this._fetch(`${this.getRoot()}${this.routes.get}`);
  },

  async clear(sections = []) {
    const body = {};
    if (sections.length) {
      body.sections = sections.join(',');
      body.sections_url = window.location.pathname;
    }
    return this._fetch(`${this.getRoot()}${this.routes.clear}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    });
  },
};

window.CartAPI = CartAPI;
